export default function preventConcurrentCalls<A extends unknown[], R>(task: (...args: A) => Promise<R>) {
	let running: Promise<R> | undefined;

	return (...args: A): Promise<R> => {
		if (!running) running = task(...args).finally(() => running = undefined);

		return running;
	};
}
